// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"7d13427a","387":"082331a5","716":"08a61fdd","722":"68a384e9","817":"67bb39ae","820":"d92b0295"}[chunkId] + ".chunk.css";
};